import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HeatReclaimGlyph = /*#__PURE__*/createElement("g", {
  id: "heat_reclaim"
}, /*#__PURE__*/createElement("path", {
  d: "M60.2 53.75h-3v-1.5c0-3.95-1.85-6.56-5.82-8.19-4.91-2.01-7.73-6.01-7.73-10.98v-1.5h3v1.5c0 2.17.76 6.1 5.82 8.19 5.13 2.09 7.73 5.79 7.73 10.99v1.49z"
}), /*#__PURE__*/createElement("path", {
  d: "M40.82 39.45c-.24 0-.48-.06-.71-.18-.73-.39-1.01-1.3-.62-2.03l3.1-5.79a2.26 2.26 0 013.06-.93l5.79 3.1c.73.39 1.01 1.3.61 2.03-.39.73-1.3 1.01-2.03.62l-5.14-2.75-2.75 5.14c-.26.5-.78.79-1.31.79zm-.51 12.98h-3v-1.5c0-2.17-.76-6.12-5.86-8.21-5.1-2.1-7.69-5.79-7.69-10.97v-1.5h3v1.5c0 3.97 1.86 6.57 5.86 8.21 4.89 2.01 7.69 6.01 7.69 10.97v1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M39.37 53.75c-.36 0-.72-.08-1.06-.27l-5.79-3.1c-.73-.39-1.01-1.3-.62-2.03a1.49 1.49 0 012.03-.61l5.14 2.75 2.75-5.14c.39-.73 1.3-1.01 2.03-.62.73.39 1.01 1.3.62 2.03l-3.1 5.79c-.41.76-1.19 1.2-2 1.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M63.63 67.51h-11.3v-3.87H18.26c-1.93 0-3.5-1.57-3.5-3.5V23.87c0-1.93 1.57-3.5 3.5-3.5h2.1V16.5h11.3v3.87h34.07c1.93 0 3.5 1.57 3.5 3.5v36.27c0 1.93-1.57 3.5-3.5 3.5h-2.1v3.87zm-8.3-3h5.3v-3.87h5.1c.28 0 .5-.22.5-.5V23.87c0-.28-.22-.5-.5-.5H28.67V19.5h-5.3v3.87h-5.1c-.28 0-.5.22-.5.5v36.27c0 .28.22.5.5.5h37.07v3.87z"
}));
const HeatReclaim = createSvg({
  name: 'heat_reclaim',
  path: HeatReclaimGlyph
});

export default HeatReclaim;
export { HeatReclaimGlyph };
